
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUItemsGrid extends Serenity.EntityGrid<SKUItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.SKUItems'; }
        protected getDialogType() { return SKUItemsDialog; }
        protected getIdProperty() { return SKUItemsRow.idProperty; }
        protected getInsertPermission() { return SKUItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SKUItemsRow.localTextPrefix; }
        protected getService() { return SKUItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}